<div class="logs-page">
    <avi-state-page [hasSidebar]="true">
        <avi-state-page_top-bar>
            <div class="logs-page__top-bar">
                <div class="logs-page__top-bar-container">
                    <ng-content select="logs-page-top-bar"></ng-content>

                    <ng-content select="logs-page-type-dropdown"></ng-content>

                    <div class="logs-page__search-bar">
                        <ng-content select="logs-page-search-bar"></ng-content>
                    </div>
                </div>

                <div class="logs-page__below-search-bar">
                    <ng-content select="logs-significance-options"></ng-content>

                    <div
                        class="logs-page__current-timeframe"
                    >
                        {{ logsStore.currentTimeframe$ | async }}
                    </div>
                </div>
            </div>
        </avi-state-page_top-bar>

        <avi-state-page_main-content>
            <!-- Message Banners -->
            <!-- Is set up in following order of importance so only one is shown at a time: -->
            <!-- If loading, show loading until complete -->
            <!-- If both error and timeout, show error -->

            <div
                class="logs-page__alert-container"
                *ngIf="(logsStore.isAnApiLoopInProgress$ | async) || (logsStore.showTimeoutMessage$ | async) || (logsStore.showErrorMessage$ | async)"
            >
                <!--  Loading Message -->
                <logs-errors
                    *ngIf="logsStore.isAnApiLoopInProgress$ | async"
                    class="logs-page__log-errors"
                    alertType="loading"
                    [show]="logsStore.isAnApiLoopInProgress$ | async"
                    [loadingStatus]="logsStore.apiLoopsInProgressStatus$ | async"
                    [loadingMessageLabel]="l10nKeys.loadingMessageLabel | vtranslate"
                    [graphLoadingMessageLabel]="l10nKeys.graphLoadingMessageLabel | vtranslate"
                    [tableLoadingMessageLabel]="l10nKeys.tableLoadingMessageLabel | vtranslate"
                ></logs-errors>

                <!--  Timeout Message -->
                <logs-errors
                    *ngIf="logsStore.showTimeoutMessage$ | async"
                    class="logs-page__log-errors"
                    alertType="warning"
                    [show]="logsStore.showTimeoutMessage$ | async"
                    (onClose)="hideTimeoutBanner()"
                    (onRefresh)="logsRefreshService.refresh()"
                    [timeoutMessageLabel]="l10nKeys.timeoutMessageLabel | vtranslate"
                    [timeoutsDocLink]="timeoutsDocLink"
                    [learnMoreLinkText]="l10nKeys.learnMoreLink | vtranslate"
                    [refreshLogsLabelText]="l10nKeys.refreshLogsLabel | vtranslate"
                ></logs-errors>

                <!--  Error Message  -->
                <logs-errors
                    *ngIf="logsStore.showErrorMessage$ | async"
                    class="logs-page__log-errors"
                    alertType="danger"
                    [show]="logsStore.showErrorMessage$ | async"
                    (onClose)="hideErrorBanner()"
                    (onAction)="reloadPage()"
                    [errorMessage]="l10nKeys.errMessageLabel | vtranslate"
                    [actionLabel]="l10nKeys.reloadPageLabel | vtranslate"
                ></logs-errors>
            </div>

            <div class="logs-page__main-content">
                <!-- <vs-logs-graph></vs-logs-graph>
                <vs-logs-actions></vs-logs-actions>
                <vs-log-list></vs-log-list> -->
                <ng-content select="logs-page-graph"></ng-content>
                <ng-content select="logs-page-actions"></ng-content>
                <ng-content select="logs-page-list"></ng-content>

            </div>
        </avi-state-page_main-content>

        <avi-state-page_sidebar>
            <!-- <vs-logs-sidebar></vs-logs-sidebar> -->
            <ng-content select="logs-page-sidebar"></ng-content>
        </avi-state-page_sidebar>
        <avi-state-page_sidebar-collapsed>
            <!-- <vs-logs-collapsed-sidebar></vs-logs-collapsed-sidebar> -->
            <ng-content select="logs-page-collapsed-sidebar"></ng-content>
        </avi-state-page_sidebar-collapsed>
    </avi-state-page>
</div>
